import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import downloadHoverIcon from '../assets/download-hover.svg';
import downloadIcon from '../assets/download.svg';
import '../styles/outfitBoardCard.css';
import { formatDate } from '../utils/utils';

// Set up PDF.js worker - using the correct version from react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

export const OutfitBoardCard = ({ outfit }) => {
  const REACT_APP_AWS_CLOUDFRONT_URL = process.env.REACT_APP_AWS_CLOUDFRONT_URL;
  const [isHovered, setIsHovered] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const pdfURL = outfit.url ? `${REACT_APP_AWS_CLOUDFRONT_URL}/${outfit.url}` : '';

  const handleCardClick = () => {
    if (pdfURL) {
      window.open(pdfURL, '_blank', 'noopener,noreferrer');
    }
  };

  const handleDownloadClick = async e => {
    e.stopPropagation(); // Prevent card click when downloading

    if (pdfURL && !isDownloading) {
      setIsDownloading(true);

      try {
        // Fetch the PDF file from the server
        const response = await fetch(pdfURL);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `${outfit.name || 'outfit'}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading PDF:', error);
      } finally {
        setIsDownloading(false);
      }
    }
  };

  return (
    <div className="outfit-card" onClick={handleCardClick}>
      <div className="outfit-card__image">
        <div className="outfit-card__placeholder">
          <Document
            file={pdfURL}
            loading={
              <div className="pdf-loading">
                <span>Loading PDF...</span>
              </div>
            }
            error={
              <div className="pdf-error">
                <span>Failed to load PDF</span>
              </div>
            }
          >
            <Page
              pageNumber={1}
              height={280}
              className="pdf-thumbnail"
              renderAnnotationLayer={false}
              renderTextLayer={false}
            />
          </Document>
        </div>
      </div>

      <div className="outfit-card__content">
        <div className="outfit-card__info">
          <h3 className="outfit-card__title">{outfit.name}</h3>
          {outfit.createdAt && <p className="outfit-card__date">{formatDate(outfit.createdAt)}</p>}
        </div>

        <div className="outfit-card__download">
          <button
            className={`outfit-card__download-btn ${isDownloading ? 'downloading' : ''}`}
            onClick={handleDownloadClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            disabled={isDownloading}
            aria-label={isDownloading ? 'Downloading...' : 'Download PDF'}
          >
            {isDownloading ? (
              <div className="download-loader">
                <div className="spinner"></div>
              </div>
            ) : (
              <>
                <img
                  src={isHovered ? downloadHoverIcon : downloadIcon}
                  alt="Download"
                  className="download-icon"
                />
                {isHovered && (
                  <div className="tooltip">
                    Download PDF
                    <div className="tooltip-arrow"></div>
                  </div>
                )}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OutfitBoardCard;
